module.exports = __webpack_public_path__ + "static/media/icon_import_success.a7636fe4.svg";